import { Color, ContentType, type Prisma } from "@brookbush/database";

import z from "zod";

export const createHighlightInput = z.object({
	contentId: z.string(),
	contentType: z.enum(ContentType),
	color: z.enum(Color),
	text: z.string(),
	startOffset: z.number(),
	endOffset: z.number(),
});

export const createNoteInput = z.object({
	contentId: z.string(),
	contentType: z.enum(ContentType),

	body: z.string(),
});

export type CreateNoteInput = z.infer<typeof createNoteInput>;

export type CreateHighlightInput = z.infer<typeof createHighlightInput>;

export type Highlight = Prisma.HighlightGetPayload<{
	include: {
		note: true;
	};
}> & {
	content?: {
		id: string;
		type: ContentType;
		title: string;
		slug: string;
	};
};
